export default __webpack_public_path__ + "static/media/tischlereirubisch_3.1b95e71f.jpg";